import { render, staticRenderFns } from "./ClientDetailPage.vue?vue&type=template&id=1c8184f3&"
import script from "./ClientDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ClientDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports